import { useEffect } from 'react';

import { LocalStore } from 'constants/localstore';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { Payload, addPending, passMonitor, setBuffer } from './monitor-req.slice';

export const useMonitorReq = () => {
  const { pending, buffer, rejectData } = useAppSelector((state) => state.monitorReq);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const payloadsJson = localStorage.getItem(LocalStore.payloads);
    localStorage.removeItem(LocalStore.payloads);
    if (payloadsJson) {
      const payloads = JSON.parse(payloadsJson) as Payload[];
      dispatch(setBuffer(payloads));
    }
  }, []);

  useEffect(() => {
    if (!pending && buffer) dispatch(addPending());
  }, [pending, buffer]);

  useEffect(() => {
    if (!pending) return;
    dispatch(passMonitor(pending));
  }, [pending]);

  useEffect(() => {
    if (rejectData) window.location.reload();
  }, [rejectData]);
};
